// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"PasswordResetEmailModal_subtitle__3Lrou","content":"PasswordResetEmailModal_content__1swWg"};